import React from "react";
import styles from "../styles/OurPeopleV2.module.css";

const OurPeopleV2 = () => {
  return (
    <section className={`section-8i ${styles.section}`} data-aos="fade-up">
      <div className="container-8i">
        {/* Keep your section title */}
        <h2 className="section-title" data-aos="fade-up">
          Our <span>Founder</span>
        </h2>

        <div className={styles.ceoHighlight} data-aos="fade-up">
          <img
            className={styles.ceoImage}
            src="/kylie_wong_founder_and_ceo_8_insights.jpg"
            alt="Kylie Wong"
            data-aos="zoom-in"
          />

          <div className={styles.ceoContent}>
            {/* Accent label inside content */}
            {/* <div className="member-eyebrow" data-aos="fade-up">
              Our Founder
            </div> */}

            {/* Global reusable name + role */}
            <h3 className="member-name" data-aos="fade-up" data-aos-delay="100">
              Kylie Wong
            </h3>

            <h5 className="member-role" data-aos="fade-up" data-aos-delay="200">
              Founder &amp; CEO
            </h5>

            <div className="content" data-aos="fade-up" data-aos-delay="300">
              <p>
                Kylie Wong is the visionary leader behind 8 Insights, bringing years of expertise in
                digital transformation and strategy. Her leadership has propelled the company into new
                heights of innovation and success.
              </p>

              <p data-aos="fade-up" data-aos-delay="400">
                Founded in 2019, the firm was created to bridge strategy and execution, offering a modern
                consultancy model built on insight, agility, and accountability. Kylie continues to lead with the
                same clarity and conviction that has guided her career: helping businesses speak with purpose,
                perform with confidence, and grow with intent.
              </p>
            </div>

            <div data-aos="fade-up" data-aos-delay="500">
              <a
                className="btn-primary-8i"
                href="https://www.linkedin.com/in/kylie-wong-8b5b7840"
                target="_blank"
                rel="noreferrer"
              >
                <i className="bi bi-linkedin"></i>
                LinkedIn
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurPeopleV2;
